export default __webpack_public_path__ + "8febb3f.png";